import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  IconButton
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '@material-ui/core/Badge';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { GrDocumentTxt, GrDocumentZip } from 'react-icons/gr';
import { BiImage } from 'react-icons/bi';
import { VscFilePdf } from 'react-icons/vsc';
import { FaRegFileWord } from 'react-icons/fa';
import { RiFileExcel2Line } from 'react-icons/ri';
import { MdPhonelinkSetup } from 'react-icons/md';

const useStyles = makeStyles(theme => ({
  root: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
function BulletinDetail({ className, BultenData, Loading, setLoading }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [PdfUrl, setPdfUrl] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation('Work_Order');

  const BultenDetayAc = log => {
    setLoading(true);
    const dataBultenDetay = {
      ServiceShopId: SessionUser.ServiceShopId,
      UserId: SessionUser.UserId,
      FilePtr: log.StreamId
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusBulletin', dataBultenDetay, config)
      .then(response => {
        // openBlob(response.data, log.BT + '_' + log.AY + '_' + log.BN);
        const fileURL = URL.createObjectURL(response.data);
        setPdfUrl(fileURL);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const renderSwitch = param => {
    switch (param) {
      case 'image/bmp':
        return <BiImage />;
      case 'image/jpeg':
        return <BiImage />;
      case 'image/gif':
        return <BiImage />;
      case 'application/pdf':
        return <VscFilePdf />;
      case 'application/x-zip-compressed':
        return <GrDocumentZip />;
      case 'application/msword':
        return <FaRegFileWord />;
      case 'application/vnd.ms-excel':
        return <RiFileExcel2Line />;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return <RiFileExcel2Line />;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return <RiFileExcel2Line />;
      case 'application/x-msdownload':
        return <MdPhonelinkSetup />;
      case 'application/unknown':
        return <MdPhonelinkSetup />;
      case 'application/octet-stream':
        return <MdPhonelinkSetup />;
      default:
        return <MdPhonelinkSetup />;
    }
  };

  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <Backdrop className={classes.backdrop} open={Loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader title={t('lblBulletins')} />
        <Divider />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3} lg={3}>
              {BultenData.map(log => (
                <ExpansionPanel
                  key={log.DocumentType}
                  expanded={expanded === log.DocumentTypeId}
                  onChange={handleChange(log.DocumentTypeId)}
                >
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.secondaryHeading}>
                      {log.DocumentType}
                      <IconButton aria-label="cart">
                        <Badge
                          badgeContent={log.Documents.length}
                          color="secondary"
                        />
                      </IconButton>
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <TableContainer component={Paper}>
                      <Table
                        className={classes.table}
                        aria-label="simple table"
                      >
                        <TableBody>
                          {log.Documents.map(row => (
                            <TableRow key={row.DocumentId}>
                              <TableCell
                                component="th"
                                onClick={e => BultenDetayAc(row)}
                                scope="row"
                              >
                                <IconButton aria-label="cart">
                                  {renderSwitch(row.StreamMimeType)}
                                </IconButton>
                                {row.StreamName}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
            </Grid>
            <Grid item xs={12} sm={9} lg={9}>
              <iframe
                width="100%"
                height="700"
                src={PdfUrl}
                style={{ border: 'none' }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

BulletinDetail.propTypes = {
  className: PropTypes.string
};

export default BulletinDetail;
